import React, { useEffect, useState } from 'react';
import { ILegalPhaseTemplateFullObject } from '../Interfaces/ILegalPhaseTemplate';
import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { Add, ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { ILegalRequirementTemplateFullObject } from '../Interfaces/ILegalRequirementTemplate';
import { ConfirmDelete } from '../core/ConfirmDelete';
import { LegalPhaseEdit } from './LegalPhaseEdit';
import { LegalPhaseCopyRequirement } from './LegalPhaseCopyRequirement';
import { ILegalRequirementTemplateDeadline } from '../Interfaces/ILegalRequirementTemplate_deadlines';
import { LegalRequirementTemplateRow } from './LegalRequirementTemplateRow';
import { EditLegalRequirementTemplate } from './EditLegalRequirementTemplate';

interface IProps {
  currentPhase: ILegalPhaseTemplateFullObject;
  legalPhaseTemplateArray: ILegalPhaseTemplateFullObject[];
  setLegalPhaseTemplateArray: Function;
  selectedRequirementsIds: number[];
  setSelectedRequirementsIds: Function;
}

export const LegalPhaseTemplateRow: React.FC<IProps> = ({
  currentPhase,
  legalPhaseTemplateArray,
  setLegalPhaseTemplateArray,
  selectedRequirementsIds,
  setSelectedRequirementsIds,
}) => {
  //
  const [currentPhaseEdit, setCurrentPhaseEdit] = useState(currentPhase);
  const [
    isOpenEditLegalRequirementTemplate,
    setIsOpenEditLegalRequirementTemplate,
  ] = useState(false);

  const handleNewReq = () => {
    setIsOpenEditLegalRequirementTemplate(true);
  };

  const updateLegalRequirementTemplateArray = (
    localLegalReqArray: ILegalRequirementTemplateFullObject[]
  ) => {
    const tmpObject = { ...currentPhase };
    tmpObject.LegalRequirementArray = localLegalReqArray;
    setLegalPhaseTemplateArray([
      ...legalPhaseTemplateArray.map(x =>
        x.idLegalPhaseTemplate === tmpObject.idLegalPhaseTemplate
          ? tmpObject
          : x
      ),
    ]);
  };

  const updateCopyArray = (
    localLegalReqArray: ILegalRequirementTemplateFullObject[]
  ) => {
    const newArray: ILegalRequirementTemplateFullObject[] = [];
    const maxPosition =
      Math.max(...currentPhase.LegalRequirementArray.map(x => x.Position)) + 1;

    localLegalReqArray.forEach((x, i) => {
      let idCounter = 1;

      if (x.DocumentArray) {
        x.DocumentArray = x.DocumentArray.map(doc => ({
          ...doc,
          idDocument: -idCounter++, // ID zuweisen, beginnend bei -1
        }));
      }

      x.Position = maxPosition + i;
      const newDeadlineArray: ILegalRequirementTemplateDeadline[] = [];
      x.DeadlineArray?.forEach(deadline => {
        if (
          deadline.idLegalRequirementTemplate !== null &&
          deadline.idLegalRequirementTemplate !== undefined
        ) {
          if (
            legalPhaseTemplateArray.some(
              legalPhase =>
                legalPhase.Position <= currentPhase.Position &&
                legalPhase.LegalRequirementArray.some(
                  legalReq =>
                    legalReq.idLegalRequirementTemplate ===
                    deadline.idLegalRequirementTemplate
                )
            )
          ) {
            newDeadlineArray.push({
              ...deadline,
            });
          }
        } else if (
          deadline.idLegalPhaseTemplate !== null &&
          deadline.idLegalPhaseTemplate !== undefined
        ) {
          if (
            legalPhaseTemplateArray.some(
              legalPhase =>
                legalPhase.Position <= currentPhase.Position &&
                legalPhase.idLegalPhaseTemplate ===
                  deadline.idLegalPhaseTemplate
            )
          ) {
            newDeadlineArray.push({
              ...deadline,
            });
          }
        } else if (
          deadline.idLegalTransactionState !== null &&
          deadline.idLegalTransactionState !== undefined
        ) {
          newDeadlineArray.push({
            ...deadline,
          });
        }
      });
      newArray.push(x);
    });
    updateLegalRequirementTemplateArray([
      ...currentPhase.LegalRequirementArray,
      ...newArray,
    ]);
  };

  const isFirstDisabled = () => {
    const currentIndex: number = legalPhaseTemplateArray
      .map(x => x.idLegalPhaseTemplate)
      .indexOf(currentPhase.idLegalPhaseTemplate);
    return currentIndex === 0;
  };

  const isLastDisabled = () => {
    const currentIndex: number = legalPhaseTemplateArray
      .map(x => x.idLegalPhaseTemplate)
      .indexOf(currentPhase.idLegalPhaseTemplate);
    return currentIndex === legalPhaseTemplateArray.length - 1;
  };

  const getUp = () => {
    const copyOfArray = [...legalPhaseTemplateArray];
    const targetPositionn = currentPhaseEdit.Position - 1;
    const toChangeObject = copyOfArray.find(
      x => x.Position === targetPositionn
    );
    const currentObject = {
      ...currentPhaseEdit,
      Position: currentPhaseEdit.Position - 1,
    };

    if (toChangeObject !== undefined) {
      const currentIndex = legalPhaseTemplateArray
        .map(x => x.idLegalPhaseTemplate)
        .indexOf(currentPhaseEdit.idLegalPhaseTemplate);
      const targetIndex = legalPhaseTemplateArray
        .map(x => x.idLegalPhaseTemplate)
        .indexOf(toChangeObject.idLegalPhaseTemplate);
      copyOfArray[currentIndex].Position =
        copyOfArray[currentIndex].Position - 1;
      copyOfArray[targetIndex].Position = copyOfArray[targetIndex].Position + 1;

      setCurrentPhaseEdit(currentObject);
      setLegalPhaseTemplateArray(copyOfArray);
    }
  };

  const getDown = () => {
    const copyOfArray = [...legalPhaseTemplateArray];
    const targetPositionn = currentPhaseEdit.Position + 1;
    const toChangeObject = copyOfArray.find(
      x => x.Position === targetPositionn
    );
    const currentObject = {
      ...currentPhaseEdit,
      Position: currentPhaseEdit.Position + 1,
    };

    if (toChangeObject !== undefined) {
      const currentIndex = legalPhaseTemplateArray
        .map(x => x.idLegalPhaseTemplate)
        .indexOf(currentPhaseEdit.idLegalPhaseTemplate);
      const targetIndex = legalPhaseTemplateArray
        .map(x => x.idLegalPhaseTemplate)
        .indexOf(toChangeObject.idLegalPhaseTemplate);

      copyOfArray[currentIndex].Position =
        copyOfArray[currentIndex].Position + 1;
      copyOfArray[targetIndex].Position = copyOfArray[targetIndex].Position - 1;

      setCurrentPhaseEdit(currentObject);
      setLegalPhaseTemplateArray(copyOfArray);
    }
  };

  const handleDelete = () => {
    setLegalPhaseTemplateArray([
      ...legalPhaseTemplateArray.filter(
        x => x.idLegalPhaseTemplate !== currentPhase.idLegalPhaseTemplate
      ),
    ]);
  };

  useEffect(() => {
    setLegalPhaseTemplateArray([
      ...legalPhaseTemplateArray.map(x =>
        x.idLegalPhaseTemplate === currentPhaseEdit.idLegalPhaseTemplate
          ? currentPhaseEdit
          : x
      ),
    ]);
  }, [currentPhaseEdit]);

  return (
    <>
      <EditLegalRequirementTemplate
        isOpenEditLegalRequirementTemplate={isOpenEditLegalRequirementTemplate}
        setIsOpenEditLegalRequirementTemplate={
          setIsOpenEditLegalRequirementTemplate
        }
        updateLegalRequirementTemplateArray={
          updateLegalRequirementTemplateArray
        }
        currentLegalPhaseTemplate={currentPhase}
      ></EditLegalRequirementTemplate>

      <TableRow>
        <TableCell colSpan={2}>{currentPhase.LegalPhaseTemplate}</TableCell>
        <TableCell>
          {currentPhase.PreconditionArray.map(x =>
            legalPhaseTemplateArray
              .filter(y => y.idLegalPhaseTemplate === x.idLegalPhaseTemplate)
              .map(y => (
                <>
                  <Typography sx={{ mr: 3 }} variant='caption'>
                    {y.LegalPhaseTemplate}
                  </Typography>
                  <br />
                </>
              ))
          )}
        </TableCell>
        <TableCell>
          <Tooltip
            title={
              !!legalPhaseTemplateArray
                .find(x => x.Position === currentPhase.Position + 1)
                ?.PreconditionArray.find(
                  x =>
                    x.idLegalPhaseTemplate === currentPhase.idLegalPhaseTemplate
                )
                ? 'Die Phase wird von der darunterliegenden Phase als Vorgänger verwendet!'
                : 'Phase nach unten verschieben'
            }
            disableInteractive
            disableHoverListener={false}
          >
            <span style={{ display: 'inline-block', float: 'right' }}>
              <IconButton
                size='small'
                disabled={
                  isLastDisabled() ||
                  !!legalPhaseTemplateArray
                    .find(x => x.Position === currentPhase.Position + 1)
                    ?.PreconditionArray.find(
                      x =>
                        x.idLegalPhaseTemplate ===
                        currentPhase.idLegalPhaseTemplate
                    )
                }
                onClick={getDown}
              >
                <ArrowDownward />
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip
            title={
              !!currentPhase.PreconditionArray.find(
                x =>
                  x.idLegalPhaseTemplate ===
                  legalPhaseTemplateArray.find(
                    x => x.Position === currentPhase.Position - 1
                  )?.idLegalPhaseTemplate
              )
                ? 'Die Phase benutzt die darüberliegende Phase als Vorgänger!'
                : 'Phase nach oben verschieben'
            }
            disableInteractive
            disableHoverListener={false}
          >
            <span style={{ display: 'inline-block', float: 'right' }}>
              <IconButton
                size='small'
                disabled={
                  isFirstDisabled() ||
                  !!currentPhase.PreconditionArray.find(
                    x =>
                      x.idLegalPhaseTemplate ===
                      legalPhaseTemplateArray.find(
                        x => x.Position === currentPhase.Position - 1
                      )?.idLegalPhaseTemplate
                  )
                }
                onClick={getUp}
              >
                <ArrowUpward />
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip title='Neue Maßnahme hinzufügen'>
            <IconButton
              sx={{ float: 'right' }}
              size='small'
              onClick={handleNewReq}
            >
              <Add />
            </IconButton>
          </Tooltip>

          <LegalPhaseCopyRequirement
            idLegalPhaseTemplate={currentPhase.idLegalPhaseTemplate}
            startId={Math.min(
              ...currentPhase.LegalRequirementArray.map(
                x => x.idLegalRequirementTemplate
              )
            )}
            setArray={updateCopyArray}
          />
        </TableCell>
        <TableCell colSpan={4} />
        <TableCell>
          <LegalPhaseEdit
            currentPhase={currentPhase}
            currentPhaseEdit={currentPhaseEdit}
            setCurrentPhaseEdit={setCurrentPhaseEdit}
            legalPhaseTemplateArray={legalPhaseTemplateArray}
            setLegalPhaseTemplateArray={setLegalPhaseTemplateArray}
          />
          <ConfirmDelete
            itemText='die aktulle Phase und deren Bedingungen'
            functionToDelete={handleDelete}
          />
        </TableCell>
      </TableRow>

      {currentPhase.LegalRequirementArray.sort((a, b) =>
        a.Position < b.Position ? -1 : 1
      ).map(x => (
        <LegalRequirementTemplateRow
          key={`idLegalRequirementTemplate-${x.idLegalRequirementTemplate}`}
          currentRequirement={x}
          legalRequirementArray={currentPhase.LegalRequirementArray}
          setLegalRequirementArray={updateLegalRequirementTemplateArray}
          legalPhaseTemplateArray={legalPhaseTemplateArray}
          selectedRequirementsIds={selectedRequirementsIds}
          setSelectedRequirementsIds={setSelectedRequirementsIds}
          currentLegalPhaseTemplate={currentPhase}
        />
      ))}
    </>
  );
};
